<template>
    <div class="card shadow">
        <div class="card-header text-center bg-sucess">
            Derniers commentaires
        </div>
        <div class="card-body p-0">
            <div class="comments-container">
                <div v-if="comments.length > 0">
                    <b-card
                        v-for="comment in comments"
                        :key="comment.id"
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <!-- <p class="comment-client">{{comment.client.name}}</p>-->
                        <p class="comment-created">
                            {{ comment.type.name }} :
                            <span class="font-italic"
                                >{{ comment.created_at_for_humans }} par
                                {{ comment.created_by.name }}</span
                            >
                        </p>
                        <hr class="mb-1 mt-1" />
                        <p class="comment-description">
                            {{ comment.description }}
                        </p>
                    </b-card>
                </div>
                <div v-else>
                    <b-card
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="comment-description">
                            Aucun commentaire n'a été rédigé sur ce tiers
                        </p>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClientNewComments',

    props: {
        client: 0,
    },

    data() {
        return {
            comments: [],
        }
    },

    async created() {
        await this.getComments()
    },

    methods: {
        async getComments() {
            {
                try {
                    const response = await axios.get(
                        `/history/home/${this.client}`
                    )
                    this.comments = response.data.data
                } catch (error) {
                    console.log(error)
                }
            }
        },
    },
}
</script>

<style scoped>
.comments-container {
    background-color: white !important;
    padding: 15px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 650px;
}

.comment-client {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
}

.comment-description {
    margin-bottom: 0;
}

.comment-created {
    font-size: 11px;
    margin-bottom: 0;
}
</style>
